//----------------------------------------------------//
//           ______      _            _
//          |  ____|    | |          (_)
//      ___ | |__  __ _ | |__   _ __  _   ___  __ _
//     / _ \|  __|/ _` || '_ \ | '__|| | / __|/ _` |
//    |  __/| |  | (_| || |_) || |   | || (__| (_| |
//     \___||_|   \__,_||_.__/ |_|   |_| \___|\__,_|
//
//				 project index.js file
//                  module loading
//          created by eFabrica / 2018-2021
//
//----------------------------------------------------//

// ---------------------------------------
// Bootstrap
// ---------------------------------------

import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/index';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';

// ---------------------------------------
// Font Awesome
// ---------------------------------------

import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';

// ---------------------------------------
// External libraries
// ---------------------------------------

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
global.jQuery = require('jquery');

import 'jquery-mousewheel';
import 'iframe-resizer';

//import 'owl.carousel';
import 'swiper';

import Handlebars from 'handlebars/dist/handlebars.min.js';
window.Handlebars = Handlebars;

import 'autocompleter';

//import 'moment';
//import 'moment/locale/sk.js';
// import moment from 'moment-timezone';
//import 'moment-timezone';
// window.moment = moment;

//import naja from 'naja';
//window.naja = naja;

//import 'anka/source/anka.js';
//import "./scripts/modules/anka.js";

import 'lazysizes';
//import 'js-cookie';
//import 'jscroll';
//import 'parsleyjs';
//import 'select2';
//import 'select2/dist/css/select2.css';
import 'jquery.cookie/jquery.cookie.js';
import 'waypoints/lib/jquery.waypoints.min.js';
// import "waypoints/lib/shortcuts/sticky.min.js";
import 'malihu-custom-scrollbar-plugin';

import 'stickybits';
import stickybits from 'stickybits';
window.stickybits = stickybits;

// import 'moment';
// import 'moment/locale/cs.js';
// import moment from 'moment-timezone';
// import 'moment-timezone';
// window.moment = moment;

import 'bootstrap-select';
import 'bootstrap-select/dist/js/i18n/defaults-cs_CZ.min.js';
import 'flatpickr';
import 'flatpickr/dist/l10n/cs.js';


import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';  // dependent on utc plugin

// OLD: import moment from 'moment-timezone';
// NEW: use dayqjs instead of moment
dayjs.extend(utc);
dayjs.extend(timezone);
window.dayjs = dayjs;
window.moment = dayjs;




// ---------------------------------------
// Internal JavaScript
// ---------------------------------------
import 'nova-tn-frontend/source/scripts/libraries/parsley.min.js'
import './scripts/main.js';
import SingleModuleLoader from './scripts/SingleModuleLoader.js';
SingleModuleLoader.Init();

// ---------------------------------------
// Internal SCSS
// ---------------------------------------

import './styles/main.scss';